<template>
    <div id="modal_component"
         class="modal-component">
        <div class="modal-area">
            <div class="modal-overlay">
                <div class="modal-overlay-inside">
                    <div class="modal-outer">
                        <div class="modal-close" @click="hideModal()"></div>
                        <div class="modal-inner">
                            <form @submit.prevent="validate">
                                <div v-if="confirmationType === 'GOOGLE_AUTHENTICATOR'">
                                    <p class="p1">Put here code from google authenticator:</p>
                                </div>
                                <div v-if="confirmationType === 'EMAIL'">
                                    <p class="p1">Check your email address.</p>
                                    <p class="p1">Put here code from message:</p>
                                </div>
                                <div v-if="confirmationType === 'NOT_CONFIGURED'">
                                    <p class="p1" style="margin-bottom: 24px;">{{ message }}</p>
                                </div>
                                <div class="modal-form-item" v-if="confirmationType === 'GOOGLE_AUTHENTICATOR' || confirmationType === 'EMAIL'">
                                    <input type="text"
                                           name="code"
                                           v-model="code"
                                           v-validate
                                           data-vv-rules="required">
                                    <p class="field-error--description"
                                       v-show="errors.has('code') && showErrors">This field is required.</p>
                                </div>
                                <div class="form-actions">
                                    <div class="button--cancel"
                                         @click="progress ? '' : hideModal()">Cancel</div>
                                    <button class="button--action button--confirm"
                                            :class="{ 'button--progress': progress }">
                                        Save</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        dependencies: ['api'],
        props: ['actionError', 'actionSuccess', 'actionSuccessParams', 'confirmationType', 'message'],
        data () {
            return {
                code: '',
                showErrors: false,
                progress: false
            }
        },
        methods: {
            hideModal () {
                this.actionError();
            },
            validate () {
                this.showErrors = false;
                this.$validator.validateAll().then(() => {
                    if (!this.errors.any()) {
                        this.submit();
                    } else {
                        this.showErrors = true;
                    }
                });
            },
            submit () {
                this.progress = true;
                this.actionSuccess(this.actionSuccessParams, this.code).then(() => {
                    this.progress = false;
                    this.hideModal();
                }, () => {
                    this.hideModal();
                });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/layout/partials/section/modals/SaveSettings.vue